module.exports = __webpack_public_path__ + "img/pg4-article2-c3.29530d8b.png";